<!--
@author: 赵静静
@time: 2021/11/8
@desc: 中标候选人公示
-->
<template>
  <div class="candidatePage mainContainer">
    <div class="title">中标候选人公示</div>
    <el-form :model="form" label-position="left" :rules="rules" ref="form" class="el-form" label-width="80px">
      <el-form-item label="候选人" required>
        <div>
          <span class="textTitle">排位一</span>
          <span class="name">{{ form.name1 }}</span>
          <el-button type="primary" size="mini" class="btnHeight_24 btWith_80" @click="mortgageChoice(1)" v-if="!form.name1">选择</el-button>
          <el-button type="primary" size="mini" class="btnHeight_24 btWith_80" @click="mortgageChoice(1)" v-else>变更</el-button>
        </div>
        <div>
          <span class="textTitle">排位二</span>
          <span class="name">{{ form.name2 }}</span>
          <el-button type="primary" size="mini" class="btnHeight_24 btWith_80" @click="mortgageChoice(2)" v-if="!form.name2">选择</el-button>
          <el-button type="primary" size="mini" class="btnHeight_24 btWith_80" @click="mortgageChoice(2)" v-else>变更</el-button>
        </div>
        <div>
          <span class="textTitle">排位三</span>
          <span class="name">{{ form.name3 }}</span>
          <el-button type="primary" size="mini" class="btnHeight_24 btWith_80" @click="mortgageChoice(3)" v-if="!form.name3">选择</el-button>
          <el-button type="primary" size="mini" class="btnHeight_24 btWith_80" @click="mortgageChoice(3)" v-else>变更</el-button>
        </div>
      </el-form-item>
    <el-form-item label="公示期" prop="publicityBetween">
      <el-select v-model="form.publicityBetween" placeholder="请选择公示天数">
        <el-option
          v-for="item in publicityBetweenList"
          :key="item.id"
          :label="item.text"
          :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
      <el-form-item label="附件">
        <el-upload
          ref="upload"
          action="#"
          class="avatar-uploader"
          :http-request="requestUpload"
          :show-file-list="false"
          :before-upload="beforeUploadList"
          :limit="1"
          :file-list="attachs"
          :on-exceed="exceedText"
        >
          <el-button type="text">上传附件</el-button>
        </el-upload>
        <div
          class="taskAffix"
          v-for="(item, index) in attachs"
          :key="index"
          @click="previewMethods(item.attachUrl)"
          @mousemove="attachDelete(index)"
          @mouseout="isDelete"
        >
          <img src="../../assets/img/public/icon_pdf.png" class="taskAffixIcon" v-if="item.fileType === 'pdf'">
          <img src="../../assets/img/public/icon_excel.png" class="taskAffixIcon" v-else-if="item.fileType ==='xls' || item.fileType ==='xlsx'">
          <img src="../../assets/img/public/icon_ppt.png" class="taskAffixIcon" v-else-if="item.fileType ==='ppt' || item.fileType ==='pptx'">
          <img src="../../assets/img/public/icon_txt.png" class="taskAffixIcon" v-else-if="item.fileType === 'txt'">
          <img src="../../assets/img/public/icon_word.png" class="taskAffixIcon" v-else-if="item.fileType ==='doc' || item.fileType === 'docx'">
          <img src="../../assets/img/public/icon_img.png" class="taskAffixIcon" v-else-if="item.fileType === 'jpg' || item.fileType === 'png'" >
          <img src="../../assets/img/public/icon_default.png" class="taskAffixIcon" v-else>
          {{ item.attachName }}
          <i class="el-icon-circle-close" v-show="attachDeleteIndex === index" @click.stop="beforeRemove(index)"></i>
        </div>
      </el-form-item>
    </el-form>
    <div class="button">
      <el-button type="warning" @click="announceResult" class="btnHeight_40 btWith_120">公布结果</el-button>
    </div>
    <el-dialog
      :visible.sync="show"
      title="请选择候选人"
      width="30vw"
      center
    >
      <div v-if="list.length === 0" class="noContent">
        <img src="../../assets/img/public/blank_icon_none.png">
      </div>
      <div v-for="(item, index) in list" :key="index" class="companyName"  @click="chosenCompany(index, item.name, item.id)" >
        <img class="active" v-if="index === isActive" src="../../assets/img/public/radio_selected.png">
        <img class="active" v-else src="../../assets/img/public/radio_default.png">
        <span class="nameText">{{ item.name }}</span>
      </div>
      <div slot="footer">
        <el-button type="warning" @click="cancel" class="btnHeight_40 btWith_120">返回</el-button>
        <el-button type="primary" @click="confirmChosenCompany" class="btnHeight_40 btWith_120">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { publicityBetweenList } from '@/utils/enumerates'
import { selectCompany, projectPublicity } from '@api/project'
import { stsOss, browseUrl } from '@api/public'
let OSS = require('ali-oss')
export default {
  name: 'candidatePage',
  data () {
    return {
      form: {
        name1: '',
        name2: '',
        name3: '',
        id1: '',
        id2: '',
        id3: ''
      },
      publicityBetweenList: publicityBetweenList,
      isActive: '', // 选中公司的下标
      companyType: '',
      companyName: '', // 选中的公司名字
      companyId: '', // 选中的公司id
      list: [],
      loading: false,
      values: [],
      show: false, // 选择中标候选人的弹窗
      rules: {
        publicityBetween: [
          { required: true, trigger: 'change', message: '请选择公示期' }
        ]
      },
      isUpload: true,
      attachs: [],
      fileData: '',
      fileName: '',
      attachDeleteIndex: ''
    }
  },
  methods: {
    // 点击选择中标候选人
    mortgageChoice (type) {
      this.selectCompany()
      if (type !== this.companyType) {
        this.isActive = ''
        this.companyName = ''
        this.companyId = ''
      }
      if (this.form.id1 && type === 1) {
        this.list.map((item, index) => {
          if (item.id === this.form.id1) {
            this.isActive = index
            this.companyId = item.id
            this.companyName = item.name
          }
        })
      }
      if (this.form.id2 && type === 2) {
        this.list.map((item, index) => {
          if (item.id === this.form.id2) {
            this.isActive = index
            this.companyId = item.id
            this.companyName = item.name
          }
        })
      }
      if (this.form.id3 && type === 3) {
        this.list.map((item, index) => {
          if (item.id === this.form.id3) {
            this.isActive = index
            this.companyId = item.id
            this.companyName = item.name
          }
        })
      }

      this.companyType = type
      this.show = true
    },
    // 获取中标公司列表
    selectCompany () {
      selectCompany({
        projectId: this.$route.query.projectId
      }).then(res => {
        if (res.data.code === 200) {
          this.list = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 点击公司
    chosenCompany (index, name, id) {
      if (this.isActive === index) {
        this.isActive = ''
        this.companyName = ''
        this.companyId = ''
      } else {
        this.isActive = index
        this.companyName = name
        this.companyId = id
      }
    },
    confirmChosenCompany () {
      if (this.companyName && this.companyId) {
        if (this.companyType === 1) {
          if (this.companyId === this.form.id2 || this.companyId === this.form.id3) {
            this.$message.error('该投标人已经是候选人，请重新选择')
            return false
          }
          this.form.name1 = this.companyName
          this.form.id1 = this.companyId
        } else if (this.companyType === 2) {
          if (this.companyId === this.form.id1 || this.companyId === this.form.id3) {
            this.$message.error('该投标人已经是候选人，请重新选择')
            return false
          }
          this.form.name2 = this.companyName
          this.form.id2 = this.companyId
        } else if (this.companyType === 3) {
          if (this.companyId === this.form.id1 || this.companyId === this.form.id2) {
            this.$message.error('该投标人已经是候选人，请重新选择')
            return false
          }
          this.form.name3 = this.companyName
          this.form.id3 = this.companyId
        }
      } else {
        if (this.companyType === 1) {
          this.form.name1 = ''
          this.form.id1 = ''
        } else if (this.companyType === 2) {
          this.form.name2 = ''
          this.form.id2 = ''
        } else if (this.companyType === 3) {
          this.form.name3 = ''
          this.form.id3 = ''
        }
      }
      this.show = false
    },
    cancel () {
      this.show = false
      this.isActive = ''
    },
    beforeUploadList (file) {
      this.fileName = this.fileNameInit('/project/bidding/', file.name)

      const isLt50M = file.size / 1024 / 1024 < 50
      const FileExt = file.name.replace(/.+\./, '')
      if (['jpg', 'png', 'txt', 'zip', 'rar', 'pdf', 'doc', 'docx', 'xlsx', 'jfif', 'jpeg'].indexOf(FileExt.toLowerCase()) === -1) {
        this.$message.warning('请上传后缀名为doc、docx、xls、ppt、pdf等常见文件格式！')
        this.isUpload = false
        return false
      } else if (!isLt50M) {
        this.$message.warning('上传文件大小不能超过50MB!')
        this.isUpload = false
        return false
      } else {
        this.fileData = file
      }
    },
    requestUpload () {
      if (this.isUpload === true) {
        stsOss().then(res => {
          if (res.data.code === 200) {
            const ossData = res.data.data
            let client = new OSS({
              region: 'oss-cn-shanghai',
              accessKeyId: ossData.accessKeyId,
              accessKeySecret: ossData.accessKeySecret,
              bucket: 'yiyong-pri',
              stsToken: ossData.stsToken,
              secure: true
            })
            if (client) {
              client.put(this.fileName, this.fileData).then(
                res => {
                  // 下面是如果对返回结果再进行处理，根据项目需要
                  if (res.res.status === 200) {
                    console.log(res)
                    this.$message.success('上传成功')
                    this.attachs.push({
                      attachName: this.fileNameUpdate(res.name),
                      attachUrl: res.url
                    })
                  } else {
                    this.$message.error('上传失败')
                  }
                }).catch(err => {
                console.log('err:', err)
              })
            }
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    previewMethods (url) {
      // 调用后端接口获取加密url
      browseUrl({
        url: url
      }).then(res => {
        if (res.data.code === 200) {
          window.open(res.data.msg)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    beforeRemove (index) {
      this.attachs.splice(index, 1)
    },
    attachDelete (index) {
      this.attachDeleteIndex = index
    },
    isDelete () {
      this.attachDeleteIndex = null
    },
    exceedText () {
      this.$message.error('最多只能上传1个')
    },
    announceResult () {
      let array = []
      array.push(this.form.id1, this.form.id2, this.form.id3)
      let excludeIds = []
      array.map(item => {
        if (item !== '') {
          excludeIds.push(item)
        }
      })
      if (excludeIds.length !== 3) {
        this.$message.error('3位候选人请填完整')
        return false
      }
      if (!this.form.publicityBetween) {
        this.$message.error('请选择公示期')
        return false
      }
      let projectWins = []
      excludeIds.map((item, index) => {
        projectWins.push({
          seqNum: index + 1,
          unitId: item
        })
      })
      this.loading = true
      projectPublicity({
        projectId: this.$route.query.projectId, // 项目id
        projectWins: projectWins, // 中标公司
        publicityBetween: this.form.publicityBetween, // 公示期
        projectPublicityAttachments: this.attachs // 附件
      }).then(res => {
        if (res.data.code === 200) {
          this.$message.success('公布成功')
          this.$router.go(-1)
          this.loading = false
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.candidatePage{
  .title{
    font-weight: bold;
    color: #333333;
    font-size: 24px;
    margin: 24px 0;
  }
  .textTitle{
    margin-right: 20px;
    color: #333333;
    font-size: 18px;
  }
  .companyName{
    width: 100%;
    line-height: 30px;
    text-align: left;
    font-size: 20px;
    color: #333;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .name{
    margin-right: 20px;
    font-size: 18px;
    color: #333333;
  }
  .button{
    width: 140px;
    margin: 0 auto;
    margin-top: 200px;
  }
  .active{
    width: 16px;
    height: 16px;
    display: inline-block;
    margin-right: 15px;
  }
  .nameText{
    display: inline-block;
  }
}
</style>
